module.exports = __webpack_public_path__ + "img/FW_AngelBlade.467e7949.png";